import React, { useEffect, useRef, useState } from 'react';
import css from './Accordion.module.css';
import { Header } from './header';
import clsx from 'clsx';
import { useScreenSize } from '@mchs/web-core';

export interface AccordionProps {
  title: string;
  children: React.ReactNode;
  startExpanded?: boolean;
  collapsable?: boolean;
}

const Accordion: React.FC<AccordionProps> = (props: AccordionProps) => {
  const [expanded, setExpanded] = useState<boolean>(
    props.startExpanded ?? false
  );
  const [height, setHeight] = useState<number | undefined>(
    expanded ? undefined : 0
  );

  const containerRef = useRef<HTMLDivElement>(null);
  const screenSize = useScreenSize();

  useEffect(() => {
    if (expanded) {
      setHeight(containerRef.current?.getBoundingClientRect().height);
    } else {
      setHeight(0);
    }
  }, [expanded, screenSize]);

  const onHeaderClicked = () => {
    setExpanded(!expanded);
  };

  return (
    <div className={css.container}>
      <Header
        title={props.title}
        expanded={expanded}
        collapsable={props.collapsable}
        onClick={onHeaderClicked}
      />
      <div className={css.content} style={{ height }}>
        <div
          className={clsx(expanded ? css.expanded : null)}
          ref={containerRef}
        >
          {expanded ? props.children : null}
        </div>
      </div>
    </div>
  );
};

export default Accordion;
